import MarketReportsService from '@/services/MarketReportsService';

export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      activeProcessQualityData: null,
    }
  },
  methods: {
  
  }
};
